import { useState } from "react";
import type { ScoreBucket } from "../types/index.ts";

interface ScoreDistributionChartProps {
  data: ScoreBucket[];
}

export function ScoreDistributionChart({ data }: ScoreDistributionChartProps) {
  const [hoverIdx, setHoverIdx] = useState<number | null>(null);

  if (data.length === 0) {
    return <div className="td-chart-empty">No distribution data</div>;
  }

  const maxCount = Math.max(...data.map((d) => d.count), 1);
  const width = 320;
  const height = 120;
  const padding = { top: 8, right: 8, bottom: 20, left: 8 };
  const chartW = width - padding.left - padding.right;
  const chartH = height - padding.top - padding.bottom;
  const barGap = 3;
  const barW = (chartW - barGap * (data.length - 1)) / data.length;

  return (
    <div className="td-dist-chart">
      <div className="td-chart-label">
        {hoverIdx !== null
          ? `${data[hoverIdx]?.bucket}: ${data[hoverIdx]?.count} projects`
          : "Score Distribution"}
      </div>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        onMouseLeave={() => setHoverIdx(null)}
      >
        <title>Score Distribution</title>
        {data.map((bucket, i) => {
          const barH = (bucket.count / maxCount) * chartH;
          const x = padding.left + i * (barW + barGap);
          const y = padding.top + chartH - barH;
          const isHovered = hoverIdx === i;

          return (
            <g key={bucket.bucket}>
              {/* biome-ignore lint/a11y/noStaticElementInteractions: SVG hover region */}
              <rect
                x={x}
                y={y}
                width={barW}
                height={barH}
                fill={isHovered ? "var(--accent-primary)" : "var(--accent-soft)"}
                opacity={isHovered ? 1 : 0.7}
                rx={2}
                onMouseEnter={() => setHoverIdx(i)}
              />
              <text
                x={x + barW / 2}
                y={height - 4}
                textAnchor="middle"
                fill="var(--muted)"
                fontSize="7"
                fontFamily="var(--font-mono)"
              >
                {bucket.bucket.split("-")[0]}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
